/**
 * LD.CLPBP.Public.Service
 * No descripton provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

'use strict';
import * as models from './models';

export interface LDCLPBPPublicApiModelsPricingMortgageFee {
    

    key?: number;

    hudNumber?: number;

    name?: string;

    borrowerCharge?: number;

    sellerCharge?: number;

    thirdPartyCharge?: number;

    lenderCharge?: number;

    totalCharge?: number;

    excludeFromTotals?: boolean;

    useTotalCharge?: boolean;

    numberOfMonths?: number;

    isPrepaid?: boolean;

    isHUDFeePrepaid?: boolean;

    isPrepaidFinanceCharge?: boolean;

    percentageOfWhat?: LDCLPBPPublicApiModelsPricingMortgageFee.PercentageOfWhatEnum;

    percentCharge?: number;

    section?: LDCLPBPPublicApiModelsPricingMortgageFee.SectionEnum;

    disclosureSectionType?: LDCLPBPPublicApiModelsPricingMortgageFee.DisclosureSectionTypeEnum;

    disclosureComparisonType?: LDCLPBPPublicApiModelsPricingMortgageFee.DisclosureComparisonTypeEnum;

    additionalInformation?: string;

    feePaidAt?: LDCLPBPPublicApiModelsPricingMortgageFee.FeePaidAtEnum;

    gfeDescription?: string;

    sumFeeInHUDNumber?: number;

    hudDescription?: string;

    borrowerPaidOutsideClosing?: boolean;

    sellerPaidOutsideClosing?: boolean;

    thirdPartyPaidOutsideClosing?: boolean;

    lenderPaidOutsideClosing?: boolean;

    brokerFeeName?: string;

    hudComparison?: LDCLPBPPublicApiModelsPricingMortgageFee.HudComparisonEnum;

    sumInGFENumber?: number;

    itemizeOnHUD?: boolean;

    waivedCode?: string;

    waivedBy?: string;

    waivedDate?: Date;

    waivedAmount?: number;

    waiverComments?: string;

    paidByDebit?: boolean;

    paidByCredit?: boolean;

    deed?: number;

    mortgage?: number;

    release?: number;

    includeItems?: string;

    generalLedgerNumber?: string;

    borrowerDatePaid?: Date;

    borrowerAmountPaid?: number;

    borrowerBalanceDue?: number;

    sellerDatePaid?: Date;

    sellerAmountPaid?: number;

    sellerBalanceDue?: number;

    thirdPartyDatePaid?: Date;

    thirdPartyAmountPaid?: number;

    thirdPartyBalanceDue?: number;

    lenderDatePaid?: Date;

    lenderAmountPaid?: number;

    lenderBalanceDue?: number;

    totalDatePaid?: Date;

    totalAmountPaid?: number;

    totalBalanceDue?: number;

    isFeeFinancedOnly?: boolean;

    isFHAAllowable?: boolean;

    isSection32?: boolean;

    isVAAllowable?: boolean;

    disbursementType?: LDCLPBPPublicApiModelsPricingMortgageFee.DisbursementTypeEnum;

    addToDisbursements?: boolean;

    netFromDisbursements?: boolean;

    documentFeeType?: string;

    paidTo?: LDCLPBPPublicApiModelsPricingMortgageFee.PaidToEnum;

    lenderPercentage?: number;

    sellerPercentage?: number;

    thirdPartyPercentage?: number;
}
export namespace LDCLPBPPublicApiModelsPricingMortgageFee {

    export enum PercentageOfWhatEnum { 
        None = <any> 'None',
        AppraisedValue = <any> 'AppraisedValue',
        PurchasePrice = <any> 'PurchasePrice',
        LessorOfSalesPriceOrAppraisalValue = <any> 'LessorOfSalesPriceOrAppraisalValue',
        TotalLoanAmount = <any> 'TotalLoanAmount',
        LoanAmount = <any> 'LoanAmount',
    }

    export enum SectionEnum { 
        OriginationCharges = <any> 'OriginationCharges',
        ServicesCannotShopFor = <any> 'ServicesCannotShopFor',
        ServicesCanShopFor = <any> 'ServicesCanShopFor',
        TaxesAndGovernmentFees = <any> 'TaxesAndGovernmentFees',
        TransferTaxes = <any> 'TransferTaxes',
        Prepaids = <any> 'Prepaids',
        InitialEscrowPaymentsAtClosing = <any> 'InitialEscrowPaymentsAtClosing',
        OtherCosts = <any> 'OtherCosts',
    }

    export enum DisclosureSectionTypeEnum { 
        None = <any> 'None',
        Points = <any> 'Points',
        OriginationMisc = <any> 'OriginationMisc',
        CannotShopforMisc = <any> 'CannotShopforMisc',
        CanShopforMisc = <any> 'CanShopforMisc',
        RecordingFeesandOtherTaxes = <any> 'RecordingFeesandOtherTaxes',
        TransferTaxes = <any> 'TransferTaxes',
        PrepaidsHomeownersInsPremium = <any> 'PrepaidsHomeownersInsPremium',
        PrepaidsMIPremium = <any> 'PrepaidsMIPremium',
        PrepaidsDailyInterest = <any> 'PrepaidsDailyInterest',
        PrepaidsPropertyTaxes = <any> 'PrepaidsPropertyTaxes',
        PrepaidsMisc = <any> 'PrepaidsMisc',
        InitialEscrowHomeownersIns = <any> 'InitialEscrowHomeownersIns',
        InitialEscrowMI = <any> 'InitialEscrowMI',
        InitialEscrowPropertyTaxes = <any> 'InitialEscrowPropertyTaxes',
        InitialEscrowMisc = <any> 'InitialEscrowMisc',
        OtherMisc = <any> 'OtherMisc',
    }

    export enum DisclosureComparisonTypeEnum { 
        None = <any> 'None',
        CannotIncrease = <any> 'CannotIncrease',
        CannotIncreaseByMoreThan10PerctInTotal = <any> 'CannotIncreaseByMoreThan10PerctInTotal',
        CanIncrease = <any> 'CanIncrease',
    }

    export enum FeePaidAtEnum { 
        NotSpecified = <any> 'NotSpecified',
        Application = <any> 'Application',
        Closing = <any> 'Closing',
        Commitment = <any> 'Commitment',
        LockIn = <any> 'LockIn',
    }

    export enum HudComparisonEnum { 
        None = <any> 'None',
        CannotIncrease = <any> 'CannotIncrease',
        CannotIncreaseByMoreThan10PerctInTotal = <any> 'CannotIncreaseByMoreThan10PerctInTotal',
        CanChange = <any> 'CanChange',
    }

    export enum DisbursementTypeEnum { 
        None = <any> 'None',
        Wire = <any> 'Wire',
        Single = <any> 'Single',
        Joint = <any> 'Joint',
    }

    export enum PaidToEnum { 
        None = <any> 'None',
        Lender = <any> 'Lender',
        Broker = <any> 'Broker',
        Other = <any> 'Other',
        LenderAffiliate = <any> 'LenderAffiliate',
        BrokerAffiliate = <any> 'BrokerAffiliate',
    }
}
